import SidebarModal from '@/components/layouts/navigation/SidebarModal';
import NotificationContent from "@/featured/apps/components/notification/NotificationContent";
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';


type Props = {};

export default function NotificationDesktopMenu({}: Props) {
    const [notificationModal, setNotificationModal] = useState(false);

    const router = useRouter();

    useEffect(() => {
        if (router.asPath.includes('#notification')) {
            setNotificationModal(true);
        } else {
            setNotificationModal(false);
        }
    }, [router.asPath]);

    const closeModal = () => {
        setNotificationModal(false);
        const currentBasePath = router.asPath.split('#')[0].split('?')[0] || '/dashboard';
        router.push(currentBasePath, undefined, { shallow: true });
    };

    return (
        <>
            <SidebarModal
                modalOpen={notificationModal}
                title="Notification"
                position="left"
                setModalClose={closeModal}
                leftside={
                    <NotificationContent/>
                }
                rightside={null}
            />
        </>
    );
}
